import React, { useState, useRef, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialInput from "../common/UI/MaterialInput";
import IconUser from "../../assets/images/IconUser";
import { Wrapper, Nav } from "./style";
import logo from "../../assets/images/logo.png";
import { Icon } from "../styledConstants";
import NavList from "./NavList";
import { navData } from "./constants";
import { useEffect } from "react";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import { userLogout } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions/user";
import { setAlert } from "../../store/actions/alert";
import { usePermissionsFromJWT } from "../../utils/DecodeJwt";
import { useSessionExpiryChecker } from "../../utils/DecodeJwt";
// import ExperienceToggleSwitch from "../../shell/ExperienceToggleSwitch";

export default function Navigation() {
  const navigate = useNavigate();
  const [navigationData, setNavigationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const filteredNavRef = useRef([]);

  const { user } = useSelector((state) => state.user);
  const refNav = useRef(null);
  const [userData, setUserData] = useState({});
  const { permissions: userPermissions } = usePermissionsFromJWT();
  const auth = sessionStorage.getItem("authToken");
  useSessionExpiryChecker(auth, () => {
    dispatch(setAlert({ message: "Your session has been expired", status: "info", timeout: 5000 }));
    logoutUser();
  });
  const hasPermission = (item, permissions) => {
    if (item.alwaysShow) {
      return true;
    }
    return !item.permissions || item.permissions.some((p) => permissions.includes(p));
  };
  const filteredNav = useMemo(() => {
    if (!userPermissions) return [];

    return navData
      .map((item) => {
        if (!hasPermission(item, userPermissions)) return null;

        if (item.subNav && Array.isArray(item.subNav)) {
          const filteredSubNav = item.subNav.filter((sub) => hasPermission(sub, userPermissions));
          return { ...item, subNav: filteredSubNav };
        }

        return item;
      })
      .filter(Boolean)
      .map((item) => ({ ...item, expanded: false })); // initial expanded state
  }, [userPermissions]);

  useEffect(() => {
    if (filteredNav.length > 0) {
      filteredNavRef.current = filteredNav;
      setNavigationData(filteredNav);
    }
    setLoading(false);
  }, [filteredNav]);

  const toggleNavigation = (e, isExpanded, index) => {
    e.preventDefault();

    const updated = navigationData.map((item, i) => ({
      ...item,
      expanded: i === index ? !isExpanded : false,
    }));

    setNavigationData(updated);
  };

  const hideSubmenu = () => {
    if (!Array.isArray(filteredNavRef.current)) return;
    const updated = filteredNavRef.current.map((item) => ({
      ...item,
      expanded: false,
    }));

    setNavigationData(updated);
  };

  // useEffect(() => {
  //   if (user?.userType) {
  //     const submitSuccess = (res) => {
  //       if (res.code === "0000") {
  //         let navigationDataCopy = [...navigationData];
  //         //  const permissions = res.data && res.data.WEB;
  //         // if (permissions && Array.isArray(permissions)) {
  //         //   const permissionsCodesArr = permissions.map((item) => item.permissionCode.toUpperCase());
  //         //   // set the active value to true/false based on the permission list
  //         //   navigationDataCopy.map((item) => (item.active = permissionsCodesArr.includes(item.id)));
  //         //   //  navigationDataCopy.map((item) => permissionsCodesArr.includes(item.id));
  //         //   setNavigationData(navigationDataCopy);
  //         // }

  //         const permissionsCodesArr = [];
  //         if (res.data) {
  //           if (user.userType === 'ROLE_MERCHANT_DISTRIBUTOR') {
  //             permissionsCodesArr.push('MANAGE_AGENT');
  //             permissionsCodesArr.push('DASHBOARD');
  //           } else {
  //             Object.keys(res.data).forEach((key) => {
  //               const permissionArrayOfObject = res.data[key];
  //               permissionArrayOfObject.forEach((item) => {
  //                 permissionsCodesArr.push(item.permissionCode);
  //               });
  //             });
  //           }

  //           navigationDataCopy.map((item) => (item.active = permissionsCodesArr.includes(item.id)));
  //           setNavigationData(navigationDataCopy);
  //         }
  //       }
  //     };
  //     const submitError = (res) => { };

  //     const api = new Request("", submitSuccess, submitError, false);
  //     return api.get(`${Config.apis.user.GET_PERMISSIONS}?roleCode=MA`);
  //   }
  // }, [user]);
  const dispatch = useDispatch();

  const handleClickOutside = (e) => {
    if (refNav.current && !refNav.current.contains(e.target)) {
      hideSubmenu();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  const logoutUser = () => {
    userLogout();
    dispatch(logout());
    navigate("/");
  };

  const isDisabled = true;

  const goProfile = () => {
    navigate("/profile");
  };
  //const auth = localStorage.getItem("authToken")

  // useEffect(() => {
  //   if (auth) {
  //     console.log("auth", auth);
  //     const token_ = auth;
  //     // const token_  = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI4ODAwNTc4ODY2IiwiYXV0aCI6IlJPTEVfQURNSU4iLCJ1c2VySWQiOiI4NzJjN2UwOC0xNjgyLTRjOGYtODk0Mi04ZWFkMTMxYjliNmUiLCJpc090cFZhbGlkYXRlZCI6ZmFsc2UsImV4cCI6MTY5NDg0NTExM30.HD_Eeg2G-KUQzUVryiE5J_YzGjn6IG2BojcvcBjopGBVWjPUE6eRA7yJtBqPHqsF_2G9ad0hCg_pV85_N3lFUg";

  //     var base64Url = token_.split(".")[1];
  //     var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //     var jsonPayload = decodeURIComponent(
  //       window
  //         .atob(base64)
  //         .split("")
  //         .map(function (c) {
  //           return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //         })
  //         .join(""),
  //     );
  //     jsonPayload = JSON.parse(jsonPayload);
  //     console.log(jsonPayload, "decoding in navigation");
  //     let expirytime = jsonPayload.exp;
  //     console.log("expirytime", expirytime);
  //     let expirationDate = new Date(expirytime * 1000);

  //     const Intervalid = setInterval(() => {
  //       try {
  //         if (expirationDate) {
  //           if (expirationDate <= Date.now()) {
  //             dispatch(setAlert({ message: "Your session has been expired", status: "info", timeout: 5000 }));
  //             clearInterval(Intervalid);
  //             logoutUser();
  //           }
  //         } else {
  //           console.error("Token is not valid");
  //         }
  //       } catch (error) {
  //         console.error("An error occurred:", error.message);
  //       }
  //     }, 2000);
  //   }
  // }, [auth]);
  if (loading) {
    return (
      <Wrapper>
        <div className="loading-spinner">Loading navigation...</div>
      </Wrapper>
    );
  }
  return (
    <Wrapper ref={refNav}>
      <Link className="logo" to="/">
        <Icon src={logo} width="141px" alt="" />
      </Link>
      {/* <MaterialInput
        icon={<IconUser />}
        disabled ={isDisabled}
        type="select"
        options={[ { label: "Logout", value: "LOGOUT" },]}
        onChange={logout}
        wrapperClassName="user-info"
       
         value={{label: user.firstName + " " + user.lastName}}
      /> */}
      <div className="user-info form-item ">
        <div className="has-value  item-select css-b62m3t-container">
          <div className="select__control css-1s2u09g-control">
            <p className="item-label-wrapper item">
              <span className="item-icon">
                <IconUser></IconUser>
              </span>
              {user?.firstName} {user?.lastName}
            </p>
          </div>
        </div>

        <div className="user-logout-box">
          <button className="mt4  user-logout">
            <p onClick={goProfile}>PROFILE</p>
            <p onClick={logoutUser}>LOG OUT</p>
          </button>
        </div>
      </div>

      {/* <div className="nav-v2-toggle">
        <ExperienceToggleSwitch />
      </div> */}

      <Nav>
        <NavList
          navData={navigationData}
          toggleNavigation={toggleNavigation}
          hideSubmenu={hideSubmenu}
          className="navlist"
        />
      </Nav>
    </Wrapper>
  );
}
